import vars from '../vars';

let $img = '<img src="" alt="">';

if (innerWidth > 1024) {
	vars.$lazyImg.each((index, item) => {
		let src = $(item).attr('data-src');

		$(item).prepend($img);
		$(item).find('img').attr('src', src);
	});
}
